import { BetStateEnum } from '@app/dev/constants/enums/betState';
import { BET_BUILDER } from '@tickets/constants';
import Config from '@app/dev/config/main';

export const isCashoutAvailable = (ticket) => {
  const { dataFromSwarm } = ticket;
  const { enableTicketAutoCashoutAmountUpdate, minimumEarlyCashoutCount } = Config.main;

  if (!dataFromSwarm?.selection_list) return false;

  const lessThanMinimumCount = dataFromSwarm.selection_list?.length < (minimumEarlyCashoutCount || 0);
  if (lessThanMinimumCount) return false;

  return dataFromSwarm.state_id === BetStateEnum.Accepted
    && dataFromSwarm.type_name !== BET_BUILDER
    && (!enableTicketAutoCashoutAmountUpdate || dataFromSwarm.cashout_amount);
};
